<template>
  <v-container fluid class="pa-0 my-4 text-left">
    <v-row class="d-md-flex" no-gutters>
      <v-col cols="12" md="6" offset-md="1" class="px-16">
        <h2 class="mb-10">
          As {{ abbreviation() }} {{ verifyUserLinkCode.companyName }} customer,
          you can draft your will
          {{
            verifyUserLinkCode.companyOffersFreeWill ? 'for free' : 'for R375'
          }}
        </h2>
        <div class="mb-8 mb-md-0">
          <SignUpForm v-if="isReferralLink" :defaultSACountry="true" />
        </div>
      </v-col>
      <v-col md="1"></v-col>
      <v-col cols="12" md="4" class="pt-0">
        <v-img
          :src="require(`@/assets/${whitelabel.images.homeMain}`)"
          alt="Online will creation"
          title="Online will creation"
          class="main-image"
        />
      </v-col>
    </v-row>

    <HomeSteps />
    <Usps />
    <Testimonials v-if="whitelabel.showHomePageTestimonials" />
  </v-container>
</template>

<script>
  import ActivateAccountForm from './ActivateAccountForm.vue';
  import SignUpForm from '../sign_up/SignUpForm.vue';
  import HomeSteps from '../HomeSteps.vue';
  import Usps from '../Usps.vue';
  import Testimonials from '../Testimonials.vue';

  export default {
    name: 'ActivateAccountPage',
    components: {
      ActivateAccountForm,
      SignUpForm,
      HomeSteps,
      Usps,
      Testimonials,
    },
    props: {
      verifyUserLinkCode: {
        required: true,
        type: Object,
      },
    },
    computed: {
      isActivationLink() {
        return this.verifyUserLinkCode.linkType == 'ACTIVATION';
      },
      isReferralLink() {
        return this.verifyUserLinkCode.linkType == 'REFERRAL';
      },
    },
    methods: {
      abbreviation() {
        const letter = this.verifyUserLinkCode.companyName[0].toLowerCase();

        return ['a', 'e', 'i', 'o', 'u'].includes(letter) ? 'an' : 'a';
      },
      getStarted() {
        const firstInputField = document.getElementById(
          'landing_page_first_input'
        );
        firstInputField.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(() => this.$nextTick().then(firstInputField.focus()), 700);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .activate-account-images {
    max-width: 170px;
    margin: 0 auto 8px auto;
  }

  .blurb {
    width: 60%;
    margin: auto;
  }

  .question-heading {
    font-size: 30px;
  }

  @media screen and (max-width: 960px) and (min-width: 600px) {
    .blurb {
      width: 35%;
      margin: auto;
    }
  }
</style>
